import { Component, Input, OnInit } from '@angular/core';
import { KPI } from '../../../@core/api';
import { NbDialogService, NbCardModule, NbListModule } from '@nebular/theme';
import { SheetDialogComponent } from '../sheet-dialog/sheet-dialog.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-linked-assets-with-pictures',
    templateUrl: './linked-assets-with-pictures.component.html',
    styleUrls: ['./linked-assets-with-pictures.component.scss'],
    standalone: true,
    imports: [NbCardModule, NbListModule, TranslateModule]
})
export class LinkedAssetsWithPicturesComponent implements OnInit {

  @Input() public assets: KPI.MappedAsset[];

  constructor(
    private dialogService: NbDialogService,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
  }

  /**
   * Display label of a linked asset. Archived equipment (e.g. the old asset
   * replaced when closing a replacement investment) gets a suffix so the user
   * can tell it apart from the active one.
   */
  public getDisplayLabel(asset: KPI.MappedAsset): string {
    const label = asset?.label ?? '';
    if (asset?.step === KPI.ASSET_STEP.ARCHIVED) {
      return `${label} ${this.translate.instant('pages.insight.asset.archived_label_suffix')}`.trim();
    }
    return label;
  }

  public navigateToAsset(assetId: number) {
    this.dialogService.open(
      SheetDialogComponent,
      {
        autoFocus: false,
        context: { assetId }
      }
    );
  }

  public getThumbnailUrl(asset: KPI.MappedAsset): string | null {
    if (!asset?.pictures || asset.pictures.length === 0) {
      return null;
    }
    const image = asset.pictures[0];
    if (!image?.thumbnail) {
      return null;
    }
    let thumbnail = image.thumbnail.trim();
    thumbnail = thumbnail.replace(/["']/g, '');
    return thumbnail || null;
  }

}
